import { LightProps, LightType, LightValue } from "./types";
import { get } from "lodash";

type LightsJSXElement = (props: LightProps) => JSX.Element;

export const LightsMap = {
  [LightType.AmbientLight]: (props: LightProps) => <ambientLight {...props} />,
  [LightType.PointLight]: (props: LightProps) => <pointLight {...props} />,
  [LightType.AreaLight]: (props: LightProps) => <rectAreaLight {...props} />,
  [LightType.SpotLight]: (props: LightProps) => <spotLight {...props} />,
};

export const getLightComponent = (lightText: LightValue) => {
  return get(LightsMap, lightText) as LightsJSXElement | undefined;
};
